import { render, staticRenderFns } from "./DetailAlurBisnisPerizinan.vue?vue&type=template&id=11e5a375&"
import script from "./DetailAlurBisnisPerizinan.vue?vue&type=script&lang=js&"
export * from "./DetailAlurBisnisPerizinan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports